module.exports = __webpack_public_path__ + "img/fundos.14eaf56c.gif";